// extracted by mini-css-extract-plugin
export var and = "Metadata-module--and--88adb";
export var authorImg = "Metadata-module--authorImg--dd4fd";
export var authorInfo = "Metadata-module--authorInfo--cac40";
export var authorLetter = "Metadata-module--authorLetter--8d0c8";
export var circleLeft = "Metadata-module--circleLeft--c84b4";
export var circleRight = "Metadata-module--circleRight--1ea73";
export var imgContainer = "Metadata-module--imgContainer--216ed";
export var many = "Metadata-module--many--93cd3";
export var metadata = "Metadata-module--metadata--7d2e6";
export var metadataText = "Metadata-module--metadataText--0984e";